var _path, _path2, _path3, _path4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicroscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3L6 2H12L13 3V3.12602C11.2748 3.57006 10 5.13616 10 7C10 8.86384 11.2748 10.4299 13 10.874V11L12 12H6L5 11V3Z",
    fill: "#3360AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 12.5304 7.21071 13.0391 7.58579 13.4142C7.96086 13.7893 8.46957 14 9 14C9.53043 14 10.0391 13.7893 10.4142 13.4142C10.7893 13.0391 11 12.5304 11 12L9 12L7 12Z",
    fill: "#3360AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7C16 8.10457 15.1046 9 14 9C12.8954 9 12 8.10457 12 7C12 5.89543 12.8954 5 14 5C15.1046 5 16 5.89543 16 7Z",
    fill: "#3360AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11.4801L16.3998 10.1999C16.9378 9.79586 17.3706 9.25929 17.6498 8.63867L19.6247 10.2186L20 10.9995V18.9995L19.7071 19.7066L16.7071 22.7066L16 22.9995H8V19.9995H5V17.9995H13V19.9995H10V20.9995H15.5858L18 18.5853V11.4801Z",
    fill: "#3360AD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 17,
    r: 1,
    fill: "#F28520"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscope);
export default __webpack_public_path__ + "static/media/microscope.b22cd20d4a6d4b096580a5051450b660.svg";
export { ForwardRef as ReactComponent };